export default {
  buyNow: {
    unavailable: 'Tato hra teď není dostupná — do košíku nebylo nic přidáno.',
    limitReached: 'Dosažen limit košíku ({limit} na transakci) — hra nebyla přidána.',
  },
  heading: 'Pokladna',
  subheading: 'Zkontrolujte a dokončete objednávku',

  empty: {
    title: 'Váš košík je prázdný.',
    hint: 'Před dokončením objednávky přidejte do košíku několik klíčů.',
    browseCatalog: 'Procházet katalog',
  },

  wallet: {
    sectionLabel: 'Způsob platby — peněženka',
    available: 'k dispozici',
    covers: 'Pokryje tuto objednávku',
    topUpAmount: 'Dobít {diff}',
  },

  billing: {
    sectionLabel: 'Fakturační údaje',
    editInSettings: 'Upravit v nastavení →',
    fieldName: 'Jméno',
    fieldEmail: 'E-mail',
    fieldCountry: 'Země',
    fieldDateOfBirth: 'Datum narození',
    fieldAddress: 'Adresa',
    missingTitle: 'Fakturační adresa chybí',
    missingHint: 'Před zadáním objednávky přidejte adresu v nastavení.',
  },

  profileGate: {
    title: 'Profil není kompletní',
    hint: 'Před dokončením objednávky je ještě potřeba doplnit:',
    completeProfile: 'Dokončit profil →',
  },

  order: {
    sectionLabel: 'Vaše objednávka',
  },

  placed: {
    chip: 'Objednávka odeslána',
    title: 'Objednávka je u nás',
    body: 'Přesměrujeme vás na vaši objednávku…',
  },

  errors: {
    lineFailed: 'Nezdařilo se',
    placeFailed: 'Některé objednávky se nepodařilo dokončit',
    partialFailureTitle: 'Některé položky nebylo možné objednat:',
    partialFailureNote: 'Úspěšné položky byly přesunuty do vašich objednávek. Ostatní zůstávají v košíku.',
  },

  aside: {
    totalToPay: 'Celkem k úhradě',
    walletDeduction: 'Bude odečteno z vaší peněženky',
    placeOrder: 'Dokončit objednávku',
    placingOrder: 'Odesílání objednávky…',
    legalBefore: 'Dokončením objednávky souhlasíte s',
    legalBetween: 'a',
    tc: 'obchodními podmínkami',
    privacy: 'zásadami ochrany osobních údajů',
    instantDelivery: 'Klíče doručeny okamžitě',
  },

  topupReturn: {
    loadingError: 'Nepodařilo se načíst stav dobití',
    missingRef: 'Chybí reference platby',
    timedOut: {
      title: 'Stále čekáme',
      body: 'Poskytovatel platby ji ještě nepotvrdil. Částka vám nebude stržena dvakrát — obnovte tuto stránku později nebo se podívejte do peněženky, kde se kredit objeví, jakmile dorazí.',
    },
    status: {
      PENDING: {
        title: 'Čekáme na potvrzení…',
        sub: 'Poskytovatel platby ji brzy potvrdí. Tato stránka se aktualizuje automaticky.',
      },
      COMPLETED: {
        title: 'Dobití proběhlo úspěšně',
        sub: 'Částka byla připsána do vaší peněženky.',
      },
      FAILED: {
        title: 'Dobití se nezdařilo',
        sub: 'Platba nebyla dokončena. Nic vám nebylo strženo.',
      },
      REFUNDED: {
        title: 'Dobití bylo vráceno',
        sub: 'Platba byla poskytovatelem stornována.',
      },
    },
    waitingSeconds: 'Čekáme {elapsed} s · aktualizujeme automaticky',
    redirecting: 'Přesměrování do peněženky…',
    backToBilling: 'Zpět na platby a fakturaci',
  },
};
